import { StyleObject } from './style-object'

export const baseStyles: StyleObject = {
  badge: {
    display: 'inline-block',
    verticalAlign: 'baseline',
    fontSize: 0,
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
    px: 1,
    borderRadius: 2,
    color: 'white',
    bg: 'primary',
  },
  button: {
    appearance: 'none',
    display: 'inline-block',
    textAlign: 'center',
    lineHeight: 'inherit',
    textDecoration: 'none',
    fontSize: 'inherit',
    px: 3,
    py: 2,
    color: 'white',
    bg: 'primary',
    border: 0,
    borderRadius: 4,
  },
  iconButton: {
    appearance: 'none',
    display: 'inline-block',
    textAlign: 'center',
    lineHeight: 'inherit',
    textDecoration: 'none',
    border: 'none',
    fontSize: 'inherit',
    padding: '4px',
  },
  input: {
    appearance: 'none',
    display: 'block',
    width: '100%',
    fontSize: 'inherit',
    color: 'inherit',
    lineHeight: 1,
    border: '1px solid',
    borderColor: '#CACACA',
    padding: '4px',
  },
  link: {
    appearance: 'none',
    display: 'inline-block',
    lineHeight: 'inherit',
    textDecoration: 'underline',
    fontSize: 'inherit',
    color: 'inherit',
  },
  popover: {
    padding: '8px 0',
    backgroundColor: 'white',
  },
  menuList: {
    padding: 0,
    overflow: 'auto',
    display: 'block',
    whiteSpace: 'nowrap',
    outline: 'none',
  },
  menuItem: {
    display: 'block',
    userSelect: 'none',
    cursor: 'pointer',
    outline: 'none',
    padding: '4px 8px',
  },
  tableWrapper: {
    width: '100%',
    overflowX: 'auto',
  },
  table: {
    display: 'table',
    width: '100%',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
  tableHead: {
    display: 'table-header-group',
    fontWeight: 600,
  },
  tableBody: {
    display: 'table-row-group',
  },
  tableRow: {
    display: 'table-row',
    color: 'inherit',
    fontWeight: 'inherit',
    fontSize: 'inherit',
    outline: 0,
    verticalAlign: 'middle',
  },
  tableCell: {
    display: 'table-cell',
    padding: '16px',
    textAlign: 'left',
    fontWeight: 'inherit',
    fontSize: 'inherit',
    color: 'inherit',
    verticalAlign: 'inherit',
  },
  tabWrappper: {},
  tab: {
    position: 'relative',
    appearance: 'none',
    display: 'inline-block',
    border: 'none',
    padding: '8px 12px',
    margin: 0,
    color: 'inherit',
    font: 'inherit',
    cursor: 'pointer',
    background: 'hsla(0, 0%, 0%, 0.05)',
  },
  tabList: {
    position: 'relative',
    display: 'flex',
  },
  tabPanels: {
    padding: '12px',
  },
  tabPanel: {},
  dialog: {
    backgroundColor: 'white',
    margin: '0 auto',
    outline: 'none',
    padding: '24px',
  },
  overlay: {
    position: 'fixed',
    padding: '32px',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    overflow: 'auto',
    background: 'rgba(0,0,0,.20)',
  },
  sliderInput: {
    width: 350,
    maxWidth: '100%',
    height: 4,
    paddingTop: 30,
    paddingBottom: 30,
    outline: 'none',
    '&[data-disabled]': {
      opacity: 0.5,
    },
  },
  sliderTrack: {
    borderRadius: '2px',
    background: '#f2f2f2',
    width: '100%',
    height: 'inherit',
  },
  sliderTrackHighlight: {
    borderRadius: 'inherit',
    background: 'black',
    height: '100%',
  },
  sliderHandle: {
    width: '12px',
    height: '12px',
    background: 'black',
    borderRadius: 999,
    zIndex: 1,
    transformOrigin: 'center',
    top: '50%',
    transform: 'translateY(-50%)',
  },
  sliderMarker: {
    width: '8px',
    height: '8px',
    background: 'inherit',
    border: '1px solid #fff',
    borderRadius: '4px',
    transformOrigin: 'center',
    '&[data-state="at-value"]': {
      background: '#1159a6',
    },
    '&[data-state="under-value"]': {
      background: '#1159a6',
    },
  },
  accordionButton: {
    appearance: 'none',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    overflow: 'visible',
    border: 'none',
    margin: 0,
    padding: '8px 12px',
    cursor: 'pointer',
    font: 'inherit',
    background: 'hsla(0, 0%, 0%, 0.05)',
  },
  accordionPanel: {
    padding: '12px',
  },
  tooltip: {
    display: 'inline-block',
    verticalAlign: 'baseline',
    whiteSpace: 'nowrap',
    padding: '4px 8px',
    background: 'hsla(0, 0%, 0%, 0.05)',
    zIndex: 1,
    pointerEvents: 'none',
    position: 'absolute',
  },
}
